/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Center_Right_Aria_LabelInputs */

const en_position_center_right_aria_label = /** @type {(inputs: Position_Center_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center right`)
};

const fr_position_center_right_aria_label = /** @type {(inputs: Position_Center_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au centre a droite`)
};

const de_position_center_right_aria_label = /** @type {(inputs: Position_Center_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitte rechts`)
};

const it_position_center_right_aria_label = /** @type {(inputs: Position_Center_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro destra`)
};

const ru_position_center_right_aria_label = /** @type {(inputs: Position_Center_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центр справа`)
};

const es_position_center_right_aria_label = /** @type {(inputs: Position_Center_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro derecha`)
};

const zh_cn2_position_center_right_aria_label = /** @type {(inputs: Position_Center_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中右`)
};

const ja_position_center_right_aria_label = /** @type {(inputs: Position_Center_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央右`)
};

const hi_position_center_right_aria_label = /** @type {(inputs: Position_Center_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र दाएँ`)
};

const pt_pt2_position_center_right_aria_label = /** @type {(inputs: Position_Center_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro-direita`)
};

/**
* | output |
* | --- |
* | "Center right" |
*
* @param {Position_Center_Right_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_center_right_aria_label = /** @type {((inputs?: Position_Center_Right_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Center_Right_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_center_right_aria_label(inputs)
	if (locale === "de") return de_position_center_right_aria_label(inputs)
	if (locale === "it") return it_position_center_right_aria_label(inputs)
	if (locale === "ru") return ru_position_center_right_aria_label(inputs)
	if (locale === "es") return es_position_center_right_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_position_center_right_aria_label(inputs)
	if (locale === "ja") return ja_position_center_right_aria_label(inputs)
	if (locale === "hi") return hi_position_center_right_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_position_center_right_aria_label(inputs)
	return en_position_center_right_aria_label(inputs)
});